const Regiones =
({
    checking,
    setChecking,
    codigosRegiones,
    setCodigosRegiones,
    checkboxesRegiones,
    setCheckboxesRegiones,
    regiones,
    sorting,
    loading,
    setPagination,
    status422
}) =>
{
    const handleChildCheckbox = (e) =>
    {
        setChecking(true);

        const checked = e.target.checked;
        const region = e.target.value;

        if (checked === true)
        {
            const regiones = [];

            for (let i = 0; i < codigosRegiones.length; i++)
            {
                regiones.push(codigosRegiones[i]);
            }

            regiones.push(region);

            setCodigosRegiones(regiones);
        }
        else
        {
            const regiones = codigosRegiones.filter(nombre => nombre !== region);

            setCodigosRegiones(regiones);
        }

        setCheckboxesRegiones(
            {
                ...checkboxesRegiones,
                [region]: checked
            });

        setPagination(1);
    }

    return (
        <div className="card border-0 mb-1">
            <div className="accordion" id="accordionPanelEspecie">
                <div className="accordion-item">
                    <h5 className="accordion-header"><button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsRegiones" aria-expanded="true" aria-controls="panelsRegiones">Regiones:</button></h5>
                    <div id="panelsRegiones" className="accordion-collapse collapse">
                        <div className="accordion-body">

                            {
                                regiones.map((region, index) =>
                                (
                                    <div className="row" key={index}>
                                        <div className="col">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`region-${index}`}
                                                    name="nombre_especie"
                                                    value={region.COD_REGION}
                                                    onChange={handleChildCheckbox}
                                                    checked={Object.hasOwn(checkboxesRegiones, `${region.COD_REGION}`) ? checkboxesRegiones[`${region.COD_REGION}`] : false}
                                                    disabled={!status422 && (!loading || checking || sorting)}
                                                />
                                                <label className="form-check-label" htmlFor={`region-${index}`}>{region.NOMBRE_REG}</label>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Regiones;
